import { Autocomplete, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, LinearProgress, Slide, TextField, Typography } from "@mui/material";
import { blue } from "@mui/material/colors";
import { forwardRef, useState } from "react";
import { validWeight } from "../booking/booking_halper";
import { orgWeightUpdate } from "./edit_halper";
import { CN_METHOD, CN_TYPES } from "../authorization/const";

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

function WeightEdit({ data, open, handleClose, onSuccess }) {
    const [inputErrors, setInputErrors] = useState({});
    const [weightLabel, setWeightLabel] = useState("Weight (Grm)");
    const [isLoading, setIsLoading] = useState(false);

    const handleSelfClose = () => {
        if (isLoading) return;
        setInputErrors({});
        setIsLoading(false);
        setWeightLabel("Weight (Grm)");
        handleClose();
    }

    const handleSelfSubmit = (event) => {
        event.preventDefault();
        const frm_data = new FormData(event.currentTarget);
        const weight = frm_data.get("weight");
        const doc_type = frm_data.get("doc_type");
        const method = frm_data.get("method");
        var flag = true;
        if (__error_handler(validWeight(weight), "weight", "Weight must be in grm.")) {
            flag = false;
        }
        setIsLoading(true);
        if (flag) {
            const _json = { "cn": data.cn_no, "weight": weight, "type": doc_type, "method": method };
            orgWeightUpdate(_json).then((_) => {
                if (onSuccess) onSuccess({ "task": "weight", ..._json });
                handleSelfClose();
            }).catch((err) => {
                setIsLoading(false);
            });
        } else {
            setIsLoading(false);
        }
    }

    const __error_handler = (test, vr, msg) => {
        if (test) {
            inputErrors[vr] = "";
            setInputErrors({ ...inputErrors });
        } else {
            inputErrors[vr] = msg;
            setInputErrors({ ...inputErrors });
        }
        return !test;
    }

    const handleWeightChange = (event) => {
        const weight = event.target.value;
        setWeightLabel("Weight (Grm) = " + (weight / 1000).toFixed(3) + "kg");
        __error_handler(validWeight(weight), "weight", "Weight must be in grm.")
    }

    if (data === null || !open) return (<></>);
    return (
        <Dialog open={open} onClose={handleSelfClose} TransitionComponent={Transition} keepMounted component="form" onSubmit={handleSelfSubmit}>
            <DialogTitle variant="h5" color="info">{data.cn_no}</DialogTitle>
            <DialogContent>
                <Grid container spacing={2}>
                    <Grid size={{ xs: 12, sm: 12 }} color={blue[500]}>
                        <Typography variant="caption">Weight Correction</Typography>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <TextField variant="outlined" name="weight" defaultValue={data.weight} fullWidth error={inputErrors.weight} type="number" slotProps={{ htmlInput: { step: 1, min: 0, max: 10000000 } }} helperText={inputErrors.weight} placeholder="Weight in Grams" label={weightLabel} onKeyUp={handleWeightChange} />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <Autocomplete
                            disablePortal
                            options={CN_TYPES}
                            defaultValue={data.type}
                            renderInput={(params) => <TextField {...params} variant="outlined" name="doc_type" fullWidth error={inputErrors.doc_type} type="text" helperText={inputErrors.doc_type} placeholder="Type" label="Type" />}
                        />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <Autocomplete
                            disablePortal
                            options={CN_METHOD}
                            defaultValue={data.method}
                            renderInput={(params) => <TextField {...params} variant="outlined" name="method" fullWidth error={inputErrors.method} type="text" helperText={inputErrors.method} placeholder="Method" label="Method" />}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            {isLoading ? <LinearProgress color="secondary" /> : ""}
            <DialogActions sx={{ pb: 3, px: 3 }}>
                <Button variant="outlined" disabled={isLoading} onClick={handleSelfClose}>Cancel</Button>
                <Button variant="contained" disabled={isLoading} color="warning" type="submit">Save</Button>
            </DialogActions>
        </Dialog>
    );
}
export default WeightEdit;